import { AbstractApi } from '../../../common/api'
import { CreateProjectDto, Project } from '../types/project.types'

class ProjectApi extends AbstractApi {
  protected url = '/projects'

  public async create(dto: CreateProjectDto): Promise<Project> {
    const { data: response } = await this.post<Project>(this.url, dto)

    return response
  }

  public async list(): Promise<Project[]> {
    const { data: response } = await this.get<Project[]>(this.url)

    return response
  }
}

export const projectApi = new ProjectApi()
